var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSearchAccaBlue = function SvgIconSearchAccaBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.333 9.334H11.667a2.333 2.333 0 0 0-2.334 2.333v36.167a2.333 2.333 0 0 0 2.334 2.333h32.666a2.333 2.333 0 0 0 2.334-2.333V11.667a2.333 2.333 0 0 0-2.334-2.333Z",
    fill: "#3987F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 5.834H21c-.644 0-1.167.522-1.167 1.167v4.666c0 .645.523 1.167 1.167 1.167h14c.644 0 1.167-.522 1.167-1.167V7.001c0-.645-.523-1.167-1.167-1.167Z",
    fill: "#2C6CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.604 34.878a5.396 5.396 0 1 0 0-10.792 5.396 5.396 0 0 0 0 10.792Z",
    fill: "#D1E6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.08 30.334h-8.457c-.645 0-1.167.522-1.167 1.167v8.458c0 .644.522 1.167 1.166 1.167h8.459c.644 0 1.166-.523 1.166-1.167v-8.458c0-.645-.522-1.167-1.166-1.167Z",
    fill: "#94C6F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m38.535 25.328-8.458-5.687a.585.585 0 0 0-.91.484v11.372c0 .467.522.744.91.484l8.458-5.687a.583.583 0 0 0 0-.969v.003Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.042 54.833c5.96 0 10.791-4.831 10.791-10.791S50.002 33.25 44.042 33.25 33.25 38.082 33.25 44.042s4.832 10.791 10.792 10.791Z",
    fill: "#FFC82A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m49.344 47.489-1.852-1.853a4.836 4.836 0 0 0 .633-2.397 4.89 4.89 0 0 0-4.885-4.886 4.89 4.89 0 0 0-4.886 4.886 4.89 4.89 0 0 0 4.886 4.885c.872 0 1.688-.23 2.397-.633l1.852 1.852a1.307 1.307 0 0 0 1.855 0 1.31 1.31 0 0 0 0-1.855Zm-8.365-4.25a2.264 2.264 0 0 1 2.26-2.26 2.264 2.264 0 0 1 2.261 2.26 2.264 2.264 0 0 1-2.26 2.26 2.264 2.264 0 0 1-2.26-2.26Z",
    fill: "#fff"
  })));
};
export default SvgIconSearchAccaBlue;